import type { IOrbitDataResponse } from "../../scheme/components/analytics/interfaces";
import { createPromiseCache } from "./promise-cache";
import { normalizeResponseArray } from "./response-array";
import type { IMultiAnalysisSignalMeasureRef } from "./signal-data";

interface IMultiAnalysisOrbitApi {
  fetchJson: (args: {
    url: string;
    method: "POST";
    data: {
      measures: readonly IMultiAnalysisSignalMeasureRef[];
    };
  }) => Promise<unknown>;
}

const ORBIT_DATA_CACHE_LIMIT = 8;
const orbitDataCache = createPromiseCache<IOrbitDataResponse[]>({ maxEntries: ORBIT_DATA_CACHE_LIMIT });

const buildOrbitDataCacheKey = (measureRefs: readonly IMultiAnalysisSignalMeasureRef[]): string =>
  JSON.stringify(measureRefs.map(({ idMeasure, date }) => [idMeasure, date]));

export const fetchMultiAnalysisOrbitData = async (
  api: IMultiAnalysisOrbitApi,
  measureRefs: readonly IMultiAnalysisSignalMeasureRef[],
): Promise<IOrbitDataResponse[]> => {
  if (!measureRefs.length) {
    return [];
  }

  const cacheKey = `${buildOrbitDataCacheKey(measureRefs)}:"full"`;
  return orbitDataCache.getOrCreate(cacheKey, () =>
    api
      .fetchJson({
        url: "/point-v2/measure/orbit/data/batch",
        method: "POST",
        data: { measures: measureRefs },
      })
      .then(response => normalizeResponseArray(response as IOrbitDataResponse[] | null | undefined)),
  );
};
